import React from "react";
import { withStyles } from "@mui/styles";

import Table from "../../components/table/Table";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

function AvailabilityRequestPlayersTable({
  classes,
  players,
  addButtonText,
  onAddButtonClick,
  hideSearch,
  additionalButtons,
  filterSelects,
  isTreasurerOrCaptain,
  myPlayer,
  rowActions,
}) {
  const headings = [
    {
      label: "NAME",
      keys: [
        {
          key: "player",
          subKey: "firstName",
        },
        {
          key: "player",
          subKey: "lastName",
        },
      ],
      getTag: (data) => data.player.id === myPlayer.id && "You",
    },
    {
      label: "RESPONSE",
      key: "isAvailable",
      type: "function",
      formatValue: (data) => {
        if (data.respondedAt) {
          if (data.isAvailable) {
            return "Yes";
          } else {
            return "No";
          }
        }

        return "";
      },
      hidden: () => false,
    },
    {
      label: "REASON",
      key: "reason",
      hidden: (data) => !isTreasurerOrCaptain && data.player.id !== myPlayer.id,
    },
  ];

  return (
    <div className={classes.section}>
      <Table
        hideSearch={hideSearch}
        addButtonText={addButtonText}
        headings={headings}
        data={players}
        onAddButtonClick={(payload) => onAddButtonClick(payload)}
        rowActions={rowActions}
        additionalButtons={additionalButtons}
        filterSelects={filterSelects}
      />
    </div>
  );
}

export default withStyles(styles)(AvailabilityRequestPlayersTable);
